import { PapiTag } from '@wix/da-papi-types';

export function measureVisibleTags(tags: PapiTag[], columnWidth: number) {
  let totalWidth = 0;
  const tagWidths = tags.map(tag => {
    const span = document.createElement('span');
    span.style.visibility = 'hidden';
    span.style.whiteSpace = 'nowrap';
    span.style.position = 'absolute';
    span.style.padding = '0 9px';
    span.innerText = tag.name;
    document.body.appendChild(span);
    const width = span.offsetWidth;
    document.body.removeChild(span);
    return width;
  });

  const plusTagWidth = 35;
  const visible: PapiTag[] = [];
  let hidden = 0;

  for (let i = 0; i < tags.length; i++) {
    if (totalWidth + tagWidths[i] + (i < tags.length - 1 ? plusTagWidth : 0) <= columnWidth) {
      visible.push(tags[i]);
      totalWidth += tagWidths[i];
    } else {
      hidden = tags.length - i;
      break;
    }
  }
  return { visible, hidden };
}
